import { AccountDto, AccountDtoPermission } from '../../interactors/gen/backendClient'

export const accountCanEdit = (account: AccountDto) => {
  return ([AccountDtoPermission.Administrator, AccountDtoPermission.Editor] as AccountDtoPermission[]).includes(
    account.permission
  )
}
